function formatAddress(info) {
  const { address, unit, city, province, postalCode } = info
  const formattedUnit = unit ? `${unit}-` : ''
  return `${formattedUnit}${address}, ${city}, ${province} ${postalCode}`
}

function formatName(info) {
  const middle = info.middleName ? info.middleName + ' ' : ''
  return `${info.firstName} ${middle}${info.lastName}`
}

function formatPhone(phone) {
  if (!phone) return ''
  return phone.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
}

function formatSectionInformation(info) {
  const values = {
    Name: formatName(info),
    Address: info.address
  }

  if (info.phone) values['Phone'] = formatPhone(info.phone)
  if (info.email) values['Email'] = info.email
  if (info.additionalName) values['Additional Name'] = info.additionalName

  return values
}

function constructDateFromDateAndTime(date, time) {
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  const hours = time.getHours()
  const minutes = time.getMinutes()

  return new Date(year, month, day, hours, minutes)
}

export { formatAddress, formatName, formatPhone, formatSectionInformation, constructDateFromDateAndTime }
